// Page d'atterrissage par rôle après connexion / restauration de session.
// Source unique utilisée par SplashScreen et Login pour éviter la divergence.
export const routeForRole = (role) => {
  if (role === 'coach') return '/coach';
  if (role === 'admin') return '/admin';
  if (role === 'editor') return '/blogs';   // rédacteur du blog → back-office
  return '/accueil';
};
